"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.bootstrapBadgeThemeClassRegistry = void 0;
const Badge_contracts_1 = require("./Badge.contracts");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.bootstrapBadgeThemeClassRegistry = {
    [Badge_contracts_1.BootstrapBadgeTheme.Black]: '--black',
    [Badge_contracts_1.BootstrapBadgeTheme.Blue]: '--blue',
    [Badge_contracts_1.BootstrapBadgeTheme.Green]: '--green',
    [Badge_contracts_1.BootstrapBadgeTheme.Red]: '--red',
    [Badge_contracts_1.BootstrapBadgeTheme.White]: '--white',
    [Badge_contracts_1.BootstrapBadgeTheme.Yellow]: '--yellow'
};
//# sourceMappingURL=Badge.config.js.map